module.exports = __webpack_public_path__ + "img/lock-yale.87cb7947.png";